module.exports = __webpack_public_path__ + "img/rosepetal-dep-endurance.d08a81d2.jpg";